var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.063,
    height: 18.063,
    viewBox: "0 0 18.063 18.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-dashboard-4660127",
    transform: "translate(-3.25 -3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9581",
    "data-name": "Tracciato 9581",
    d: "M4.024,3.25a.774.774,0,0,0-.774.774v6.193a.774.774,0,0,0,.774.774h6.193a.774.774,0,0,0,.774-.774V4.024a.774.774,0,0,0-.774-.774Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9582",
    "data-name": "Tracciato 9582",
    d: "M4.024,13.25a.774.774,0,0,0-.774.774v6.193a.774.774,0,0,0,.774.774h6.193a.774.774,0,0,0,.774-.774V14.024a.774.774,0,0,0-.774-.774Z",
    transform: "translate(0 0.321)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9583",
    "data-name": "Tracciato 9583",
    d: "M13.25,4.024a.774.774,0,0,1,.774-.774h6.193a.774.774,0,0,1,.774.774v6.193a.774.774,0,0,1-.774.774H14.024a.774.774,0,0,1-.774-.774ZM14.8,4.8V9.443h4.645V4.8Z",
    transform: "translate(0.321)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9584",
    "data-name": "Tracciato 9584",
    d: "M13.25,14.024a.774.774,0,0,1,.774-.774h6.193a.774.774,0,0,1,.774.774v6.193a.774.774,0,0,1-.774.774H14.024a.774.774,0,0,1-.774-.774ZM14.8,14.8v4.645h4.645V14.8Z",
    transform: "translate(0.321 0.321)",
    fill: "currentColor",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.6feae4760e07637862d4e37b90ea5776.svg";
export { ForwardRef as ReactComponent };